<template>
<v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title class="grey lighten-4">
                    <v-tooltip top>
                         <v-btn
                            slot="activator"
                            dark
                            @click.stop="helpdialog = true"
                            icon class="mx-0">
                        <v-icon color="red">help</v-icon>
                        </v-btn>
                        <span>Cajas/App</span>
                    </v-tooltip>
                    <h3 class="headline mb-0">Administración de Conceptos</h3>

                    <v-spacer></v-spacer>
                        <v-text-field
                            @change="onChange"
                            slot="input"
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click="addConcepto">Nuevo Concepto</v-btn>
                </v-card-title>
                <div>

                  <v-data-table
                    :headers="headers"
                    :items="conceptos"
                    :pagination.sync="pagination"
                    :total-items="total"
                    :rows-per-page-items="rowsPerPageItems"
                    :loading="loading"
                    row
                    wrap
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.code.toUpperCase() }}</td>
                      <td>{{ props.item.name }}</td>
                      <td>{{ props.item.categoria}}</td>
                      <td>{{ Number(props.item.amount).toLocaleString('de-DE') }}</td>
                      <td class="justify-center layout px-0">

                      <v-tooltip top>
                          <v-btn slot="activator" icon class="mx-0" @click="editItem(props.item)">
                            <v-icon color="info">edit</v-icon>
                          </v-btn>
                          <span>Editar Concepto</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn :disabled="props.item.id <= 5" slot="activator" icon class="mx-0" @click="deleteItem(props.item)">
                          <v-icon color="red">
                            delete
                          </v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                      </v-tooltip>

                      </td>

                    </template>
                  </v-data-table>
                </div>

            </v-card>
        </v-flex>


  <!-- Inicio de dialogo -->
    <v-dialog
          v-model="helpdialog"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Conceptos</v-card-title>

            <v-card-text>
              Visualización, Creación, Edición y Eliminación de los Conceptos de Servicio.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="helpdialog = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

    <!-- dialog para form -->
    <v-dialog v-model="dialog" width="800">
      <FormConceptos :loading="loading" :tipo="tipo" :datos="getConceptos" v-on:closeDialogConcepto="closeDialogConcepto($event)" v-on:responseLoading="loading = $event" />
    </v-dialog>
    <!-- fin dialog form  -->


    <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
            <v-card-text>
              Porfavor Espere...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    </v-layout>
</template>

<script>
import axios from 'axios'
import FormConceptos from '~/components/form/FormConceptos.vue'



  export default {
    name: "admin-concepto-view",

    components: {
        FormConceptos
    },

    computed: {

        formTitle () {
            return this.editedIndex === -1 ? 'Nuevo Concepto' : 'Editar Concepto'
        },

        getConceptos () {
            return this.editedItem
        }

    },

    data: () => ({
      dialog: false,
      helpdialog: false,
      loading: false,
      total: 0,
      tipo: '',
      search: '',
      pagination: {},
      headers: [
        { text: 'CODIGO', align: 'left', sortable: false, value: 'code' },
        { text: 'CONCEPTO', align: 'left', sortable: false, value: 'name' },
        { text: 'CATEGORIA', align: 'left', sortable: false, value: 'categoria' },
        { text: 'MONTO', align: 'left', sortable: false, value: 'amount' },
        { text: 'ACCIONES', align: 'center', value: '', sortable: false }
      ],
      rowsPerPageItems: [10, 20, 50, 100],
      conceptos: [],
      editedIndex: -1,
      editedItem: {
        code: '',
        name: '',
        category_id: ''
      },
      defaultItem: {
        code: '',
        name: '',
        category_id: ''
      }
    }),

    watch: {

        dialog (val) {
            val || this.close()
        },

        pagination() {
            this.getConceptosByPagination();
        }

    },

    methods: {

        editItem (item) {
            this.tipo = "editar"
            this.editedIndex = this.conceptos.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        addConcepto () {
            this.tipo = "crear"
            this.dialog = true
        },

        async openPdfReport(item,tipo) {
            this.loading = true
            let downloadStatus = false
            await axios.post(`/api/administration/cajas/search-report`,{ item: item, tipo: tipo })
            .then(() => downloadStatus = true)
            .catch(e => {
                if (e.response.data.errors) {
                    if (e.response.data.errors.denegado) {
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: e.response.data.errors.denegado[0]
                        })
                    }
                }else {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: e.response.data.error
                    })
                }
            })

            if(downloadStatus){
                await axios({
                    url: `/api/administration/cajas/download-report/${item.id}/${tipo}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                .then(response => {
                    const blob = new Blob([response.data], {type: response.data.type});
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = response.headers['content-disposition'];
                    let fileName = 'unknown';
                    if (contentDisposition) {
                        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (fileNameMatch.length === 2)
                            fileName = fileNameMatch[1];
                    }
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
            }

            this.loading = false
        },

        close () {
            this.dialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                this.tipo = ''
            }, 300)
        },

        async getConceptosByPagination() {
                this.loading = true;
                if (this.search) {
                    await axios.get(`/api/administration/conceptos-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.conceptos = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
                if (this.pagination.sortBy && !this.search) {
                    const direction = this.pagination.descending ? 'desc' : 'asc';
                    await axios.get(`/api/administration/conceptos-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.conceptos = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
                if(!this.search && !this.pagination.sortBy) {
                    await axios.get(`/api/administration/conceptos?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.conceptos = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
            },

            onChange () {
                this.getConceptosByPagination();
            },

            deleteItem (item) {
              if(item.id == 3){
                this.$store.dispatch('responseMessage', {
                  type: 'error',
                  text: 'Este concepto no puede ser eliminado'
                })
              }else {
                const index = this.conceptos.indexOf(item)
                let confirmDelete =  confirm(`se eliminará el Concepto:  ${item.code}, está seguro?`) && this.conceptos.splice(index, 1)
                if(confirmDelete){
                    axios.delete(`/api/administration/conceptos/${item.id}`)
                    .then(()=>{
                        this.conceptos.splice(index, 1);
                        this.$store.dispatch('responseMessage', {
                          type: 'success',
                          text: 'Concepto Eliminado'
                        })
                    })
                    .catch(error => {
                        this.$store.dispatch('responseMessage', {
                          type: 'error',
                          text: 'Error al eliminar concepto'
                        })
                        console.log(error.response);
                    });
                }
              }
            },

            closeDialogConcepto (response) {
              console.log(response, 'response')
              console.log(this.conceptos, 'conceptos')
                if (response != null) {
                    var item = this.conceptos.find(concepto => concepto.concept_id === response.id)
                    if (this.tipo == 'crear') {
                        this.conceptos.push(response)
                    }else {
                        Object.assign(item, response)
                    }
                    this.getConceptosByPagination();
                }
                this.dialog = false
                setTimeout(function(){
                    this.editItem = {}
                    this.tipo = ''
                }, 3000)

            }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/concepts.vue